import { MODULES, ROLES } from '@/constants'
import store from '@/store'
import ability from '@/store/ability'

export default [
  {
    title: 'general.mainmenu',
    name: 'MenuMain',
    subitems: [
      {
        title: 'general.dashboard',
        name: 'Dashboard',
        icon: 'home',
        to: { name: 'dashboard' },
        permission: MODULES.DASHBOARD
      },
      {
        title: 'general.fuseboxes',
        name: 'Fuseboxes',
        icon: 'list',
        to: { name: 'fusebox.index' },
        permission: MODULES.FUSEBOX
      },
      {
        title: 'general.access',
        name: 'Access',
        icon: 'link',
        to: { name: 'access.index' },
        permission: () => {
          return store.getters['auth/role'] === ROLES.OWNER.ROLE_OWNER && (!!store.getters['auth/requests'] || !!store.getters['auth/user'].managed_by)
        },
        badge: () => {
          return !!store.getters['auth/requests'] && store.getters['auth/role'] === ROLES.OWNER.ROLE_OWNER
        },
        badgeCount: () => {
          return store.getters['auth/requests'].length
        }
      },
      {
        title: 'general.labels',
        name: 'Labels',
        icon: 'tags',
        to: { name: 'label.index' },
        permission: MODULES.LABEL
      },
      {
        title: 'general.locations',
        name: 'Locations',
        icon: 'location',
        to: { name: 'location.index' },
        permission: () => {
          return ability.can('view', MODULES.LOCATION) && store.getters['auth/role'] !== ROLES.OWNER.ROLE_OWNER
        }
      }
    ]
  },
  {
    title: 'general.settings',
    name: 'MenuSettings',
    subitems: [
      {
        title: 'general.users',
        name: 'Users',
        icon: 'users',
        to: { name: 'user.index' },
        permission: MODULES.USER
      },
      {
        title: 'general.my_profile',
        name: 'Profile',
        icon: 'user',
        to: { name: 'profile.index' }
      },
      {
        title: 'general.companyProfile',
        name: 'Company profile',
        icon: 'company',
        to: { name: 'company.index' },
        permission: MODULES.COMPANY
      },
      {
        title: 'general.payment',
        name: 'Payment',
        icon: 'plans',
        to: { name: 'payment.index' },
        permission: MODULES.PAYMENT
      }
    ]
  }
]
